export default __webpack_public_path__ + "static/media/HTML5.2f5fbe6b.SVG";